export default "__VITE_ASSET__BOYimIvt__"